export default __webpack_public_path__ + "sounds/framework/notOK_R.5f741b5c.mp3?5f741b5c";